export const projectFile = 'root'
export const sourcePath = window.hasKrpano
  ? `./factory_Trump/frontEnd/plugin/${projectFile}/`
  : './'
